import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedService {
  private readonly sidebarOpen = new BehaviorSubject<boolean>(false);
  sidebarOpen$ = this.sidebarOpen.asObservable();

  toggleSidebar(): void {
    this.sidebarOpen.next(!this.sidebarOpen.value);
  }

  closeSidebar(): void {
    this.sidebarOpen.next(false);
  }

  openSidebar(): void {
    this.sidebarOpen.next(true);
  }
}
